import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import { useEffect } from "react";

const RichTextEditor = ({ value, onChange }) => {
    const editor = useEditor({
        extensions: [StarterKit],
        content: value || "",
        onUpdate: ({ editor }) => {
            onChange(editor.getHTML());
        }
    });

    useEffect(() => {
        if (editor && value !== editor.getHTML()) {
            editor.commands.setContent(value || "");
        }
    }, [value]);

    if (!editor) return null;

    return (
        <div>
            {/* Toolbar */}
            <div className="mb-2">
                <button onClick={() => editor.chain().focus().toggleBold().run()} className="btn btn-sm btn-light me-1">B</button>
                <button onClick={() => editor.chain().focus().toggleItalic().run()} className="btn btn-sm btn-light me-1">I</button>
                <button onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()} className="btn btn-sm btn-light me-1">H2</button>
                <button onClick={() => editor.chain().focus().toggleBulletList().run()} className="btn btn-sm btn-light me-1">• List</button>
            </div>

            {/* Editor */}
            <EditorContent
                editor={editor}
                className="form-control"
                style={{ minHeight: "200px" }}
            />
        </div>
    );
};

export default RichTextEditor;